import { debounceCallback } from "@caprikorn/dynamo-utils";
import { useQuery } from "@tanstack/react-query";

import { useGroupReferences } from "@contexts/GroupReferences/GroupReferences.context";
import { apiEcmsHttp } from "@services/http";
import { QUERY_KEYS } from "@services/keys";

import type { GetContracts, GetContractsParams } from "./apiEcms.types";

const getContracts = async (
  { pageNumber, customerId, elementsPerPage, search }: GetContractsParams,
  signal: AbortSignal,
) => {
  const { data } = await apiEcmsHttp.get<GetContracts>("/contracts", {
    params: {
      pageNumber,
      elementsPerPage,
      customerId,
      q: search,
    },
    signal,
  });

  return data;
};

const debounceGetContracts = debounceCallback(getContracts);

export const useGetContracts = ({
  pageNumber,
  elementsPerPage,
  customerId,
  search,
}: GetContractsParams) => {
  const { currentGroup } = useGroupReferences();

  return useQuery({
    queryKey: [
      QUERY_KEYS.PERIMETER_DATA,
      QUERY_KEYS.PERIMETER_CONTRACTS_DATA,
      pageNumber,
      customerId,
      search,
      elementsPerPage,
      currentGroup,
    ],
    queryFn: ({ signal }) =>
      debounceGetContracts(
        {
          pageNumber,
          customerId,
          elementsPerPage,
          search,
        },
        signal,
      ),
  });
};
